import React, { useEffect } from 'react';
import { StyledGoToManifesto } from './StyledGoToManifesto';
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const GoToManifesto = ({ }) => {
 
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }

  useEffect(() =>{
   
  }, [])
    
  

  return (
    <React.Fragment>
      {
       
        <StyledGoToManifesto>
          <div className="text--wrap">
            <h5 className="big--title">Welcome to <span>Full Reality</span></h5>
            <div className="cta--primary cursor-cta" onClick={() => handleCLick('/full-reality')}>
              <p className="preset-10 cursor-cta">Read the Manifesto</p>
              <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke="#ffffff" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
                <path className="cursor-cta" d="M13 6H1" stroke="#ffffff" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
            </div>
          </div>
        </StyledGoToManifesto>
          
      }
    </React.Fragment>
  );
};


export default GoToManifesto;
